import { c as _c } from "react/compiler-runtime";
import ActionWorldCard from '@/components/ActionWorldCard';
import { useUAContext } from '@/context/UAContext';
import { cn } from '@/lib/utils';
import type { Room } from '@/services/cms';
type PremiumPlanWorldsProps = {
  worlds?: Room[];
};
const PremiumPlanWorlds = t0 => {
  const $ = _c(5);
  const {
    worlds
  } = t0;
  const {
    isMobile
  } = useUAContext();
  let t1;
  if ($[0] !== isMobile || $[1] !== worlds) {
    t1 = worlds?.map(world => <div key={world.id}><ActionWorldCard className={cn({
        "aspect-[1.72] w-full": !isMobile
      })} info={world} hideLiked={true} /></div>);
    $[0] = isMobile;
    $[1] = worlds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="grid grid-cols-2 gap-x-3 gap-y-4 md:grid-cols-3">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default PremiumPlanWorlds;